import React from "react";
import { motion } from "framer-motion";

/* ─── Only rows that a producer will accept without a fight.
       Cost + time. Everything else lives in VawWorldOS. ─────────── */
const ROWS = [
  { label: "Cost per finished minute",   trad: "$110–170k",    vaw: "$38–55k",       delta: "−65%", highlight: true  },
  { label: "90-min feature · all-in",    trad: "$8M – $14M",   vaw: "Under $2M",     delta: "−80%", highlight: true  },
  { label: "Delivery — script to DCP",   trad: "22–30 months", vaw: "12–14 months",  delta: "−50%", highlight: true },
];

export default function CostAdvantage() {
  return (
    <section className="vw-section relative" data-testid="vw-cost">
      <div className="vw-container">
        <div className="mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div>
            <div className="vw-eyebrow mb-6">THE COST ADVANTAGE · APPLES-TO-APPLES</div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[0.92] tracking-tight max-w-[16ch]">
              40–60% lower <span className="font-serif-italic font-normal text-[var(--vw-orange)]">production cost</span>. Same 4K master.
            </h2>
          </div>
          <p className="max-w-md text-[var(--vw-text-dim)] leading-relaxed">
            Two producers. Same 90-minute brief. Same 4K + Dolby Atmos deliverable. The only variable is us. Numbers below are from 24 completed reference projects.
          </p>
        </div>

        <div className="border border-[var(--vw-border)] overflow-hidden">
          {/* Header row */}
          <div className="grid grid-cols-[2.2fr_1fr_1fr_0.7fr] bg-[var(--vw-surface)] border-b border-[var(--vw-border)]">
            <div className="p-4 md:p-5 font-mono text-[10px] uppercase tracking-[0.28em] text-[var(--vw-text-mute)]">
              Metric
            </div>
            <div className="p-4 md:p-5 font-mono text-[10px] uppercase tracking-[0.28em] text-[var(--vw-text-mute)] border-l border-[var(--vw-border)]">
              LA / Vancouver mid-tier
            </div>
            <div className="p-4 md:p-5 font-mono text-[10px] uppercase tracking-[0.28em] text-[var(--vw-cyan)] border-l border-[var(--vw-border-strong)] bg-[color:rgba(0,229,255,0.05)]">
              VawWorld
            </div>
            <div className="p-4 md:p-5 font-mono text-[10px] uppercase tracking-[0.28em] text-[var(--vw-text-mute)] border-l border-[var(--vw-border)] text-right">
              Delta
            </div>
          </div>

          {ROWS.map((r, i) => (
            <motion.div
              key={r.label}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.05 }}
              className={`grid grid-cols-[2.2fr_1fr_1fr_0.7fr] border-b border-[var(--vw-border)] last:border-b-0 group ${r.highlight ? "bg-[var(--vw-bg-soft)]" : ""}`}
              data-testid={`vw-cost-row-${i}`}
            >
              <div className="p-4 md:p-6 font-display text-lg md:text-xl text-[var(--vw-text)]">
                {r.label}
              </div>
              <div className="p-4 md:p-6 font-mono text-sm md:text-base text-[var(--vw-text-dim)] border-l border-[var(--vw-border)] flex items-center">
                {r.trad}
              </div>
              <div className="p-4 md:p-6 font-mono text-sm md:text-base border-l border-[var(--vw-border-strong)] flex items-center gap-2 text-[var(--vw-cyan)]">
                <span className="w-1.5 h-1.5 bg-[var(--vw-cyan)]" />
                {r.vaw}
              </div>
              <div className="p-4 md:p-6 font-mono text-sm text-[var(--vw-orange)] border-l border-[var(--vw-border)] flex items-center justify-end">
                {r.delta}
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-4 text-xs font-mono uppercase tracking-[0.22em] text-[var(--vw-text-mute)]">
          <span>* Ranges based on 24 completed reference projects</span>
          <span className="w-8 h-px bg-[var(--vw-border-strong)]" />
          <span>Discovery call includes a project-specific delta model</span>
        </div>
      </div>
    </section>
  );
}
